import {
    addToChainBefore,
    ApiHandler,
} from "@insite/client-framework/HandlerCreator";
import { Session } from "@insite/client-framework/Services/SessionService";
import {
    chain,
    DispatchCompleteSignIn,
    SignInParameter,
    SignInResult,
} from "@insite/client-framework/Store/Context/Handlers/SignIn";
import { getCookie } from "@insite/mobius/utilities/cookies";

type HandlerType = ApiHandler<
    SignInParameter,
    SignInResult,
    {
        tokenSuccessfullyRequested?: boolean;
        authenticatedSession?: Session;
    }
>;

export const ForceLoginForSSO: HandlerType = props => {
    const shouldForceLogin = getCookie("ForceRelogin");
    if (shouldForceLogin === "true") {
        return false;
    }
};

addToChainBefore(chain, DispatchCompleteSignIn, ForceLoginForSSO);
